const map = {
	"./Agencies_image.png": 32280,
	"./agency_image.png": 12704,
	"./ben_admin_image.png": 25262,
	"./benefit_admin_image.png": 35904,
	"./ease_image.png": 63523,
	"./tech_platform_image.png": 26595,
	"./technology_partner_image.png": 99668
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40176;